/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const DeviceMobileLandscape24Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 24, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="DeviceMobileLandscape24Icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path d="M17 13V10H16V13H17Z" fill="currentColor" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5 8.5V14.5C5 15.3284 5.67157 16 6.5 16L17.5 16C18.3284 16 19 15.3284 19 14.5V8.5C19 7.67157 18.3284 7 17.5 7H6.5C5.67157 7 5 7.67157 5 8.5ZM6 14.5L6 8.5C6 8.22386 6.22386 8 6.5 8L17.5 8C17.7761 8 18 8.22386 18 8.5V14.5C18 14.7761 17.7761 15 17.5 15L6.5 15C6.22386 15 6 14.7761 6 14.5Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

DeviceMobileLandscape24Icon.tags = [
  'mobile',
  'landscape',
  'device',
  'tablet',
  'screen',
];

DeviceMobileLandscape24Icon.category = '24x24';

DeviceMobileLandscape24Icon.iconSize = 24;
